<template>

<div id="back">
  <button @click="$router.go(-1)"><font-awesome-icon :icon="['fas', 'reply']" /> {{ this.$i18n.t("back") }}</button>
  <router-link :to="{ name: 'home' }"><font-awesome-icon :icon="['fas', 'reply']" /> {{ this.$i18n.t("IslDyn_return StartPage") }}</router-link>
</div>

</template>


<script>

export default { 
  name: "BackComponent",
}

</script>



<style scoped lang="scss">

#back {
  @include flex-center;
  justify-content: flex-start;
  width: 100%;
  font-size: 14px;
  padding: 0 50px 30px 0px;
}
  #back .fas {
    font-size: 75%;
    padding-right: 4px;
  }
  #back button {
    @include button-styles;
    color: $text-color;
    font-weight: 500;
    padding: 2px 8px 2px 0;
  }
  #back a {
    padding: 2px 8px 2px 0;
    color: $text-color;
    font-weight: 500;
    text-decoration: none;
  }

@media only screen and (max-width: 599px) {
  #back {
    padding: 0 0 30px 0;
  }
}

</style>